// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Modern Conversation List (UsersList)
   LeistFusion Brand Palette (Teal / Slate / Sky)
   ============================================================ */

.chat-users {
  display: flex;
  flex-direction: column;
  width: 320px;
  flex-shrink: 0;
  min-height: 0;
  border-inline-end: 1px solid #eef2f6;
  background: #ffffff;
}

.chat-users__header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 16px 14px 16px;
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
}

.chat-users__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.chat-users__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.chat-users__new-btn {
  width: 34px !important;
  height: 34px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #157f9f !important;
  background: #ecf7fb !important;
  transition: all 0.2s ease !important;
  font-size: 16px !important;
}

.chat-users__new-btn:hover {
  background: #d5eef6 !important;
  color: #0e6580 !important;
  transform: scale(1.05);
}

.chat-users__header .ant-input-affix-wrapper {
  border-radius: 20px !important;
  padding: 6px 14px !important;
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.chat-users__header .ant-input-affix-wrapper:focus-within {
  background: #ffffff !important;
  border-color: #2a9dc0 !important;
  box-shadow: 0 0 0 3px rgba(42, 157, 192, 0.15) !important;
}

.chat-users__list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 8px 6px;
}

.chat-users__list::-webkit-scrollbar {
  width: 5px;
}

.chat-users__list::-webkit-scrollbar-track {
  background: transparent;
}

.chat-users__list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.25);
  border-radius: 10px;
}

.chat-users__list::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.5);
}

.chat-users .chat-users__item {
  min-height: 60px;
  padding: 10px 12px;
  margin: 2px 4px;
  border-radius: 12px;
  border: none !important;
  cursor: pointer;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.chat-users .chat-users__item:hover {
  background: #f8fafc;
}

.chat-users .chat-users__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px #2a9dc0;
}

.chat-users .chat-users__item.is-active {
  background: #ecf7fb;
}

.chat-users .chat-users__item.is-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3.5px;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, #2a9dc0 0%, #157f9f 100%);
}

[dir="rtl"] .chat-users .chat-users__item.is-active::before {
  left: auto;
  right: 0;
  border-radius: 4px 0 0 4px;
}

.chat-users__avatar {
  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 5px rgba(21, 127, 159, 0.2);
}

.chat-users .chat-users__item .ant-list-item-meta {
  align-items: center;
  min-width: 0;
}

.chat-users .chat-users__item .ant-list-item-meta-content {
  min-width: 0;
}

.chat-users .chat-users__item .ant-list-item-meta-title {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}

.chat-users .chat-users__item.is-active .ant-list-item-meta-title {
  color: #0e6580;
  font-weight: 700;
}

.chat-users .chat-users__item .ant-list-item-meta-description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8125rem;
  color: #64748b;
  margin-top: 2px;
}

.chat-users .chat-users__item.is-active .ant-list-item-meta-description {
  color: #334a60;
}

.chat-users__unread-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #157f9f;
  box-shadow: 0 0 0 2px #ffffff, 0 0 8px rgba(21, 127, 159, 0.5);
  display: inline-block;
  flex-shrink: 0;
  margin-left: 6px;
}

[dir="rtl"] .chat-users__unread-dot {
  margin-left: 0;
  margin-right: 6px;
}

/* Phones/tablets: the list is the whole screen until a conversation opens. */
.chat-page--compact .chat-users {
  width: 100%;
  border-inline-end: 0;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Chats/Users/UsersList.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,8DAA8D;EAC9D,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,oBAAoB;AACtB","sourcesContent":["/* ============================================================\n   Modern Conversation List (UsersList)\n   LeistFusion Brand Palette (Teal / Slate / Sky)\n   ============================================================ */\n\n.chat-users {\n  display: flex;\n  flex-direction: column;\n  width: 320px;\n  flex-shrink: 0;\n  min-height: 0;\n  border-inline-end: 1px solid #eef2f6;\n  background: #ffffff;\n}\n\n.chat-users__header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 16px 14px 16px;\n  border-bottom: 1px solid #eef2f6;\n  background: #ffffff;\n}\n\n.chat-users__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.chat-users__title {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.chat-users__new-btn {\n  width: 34px !important;\n  height: 34px !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #157f9f !important;\n  background: #ecf7fb !important;\n  transition: all 0.2s ease !important;\n  font-size: 16px !important;\n}\n\n.chat-users__new-btn:hover {\n  background: #d5eef6 !important;\n  color: #0e6580 !important;\n  transform: scale(1.05);\n}\n\n.chat-users__header .ant-input-affix-wrapper {\n  border-radius: 20px !important;\n  padding: 6px 14px !important;\n  background: #f8fafc !important;\n  border: 1px solid #e2e8f0 !important;\n  transition: all 0.2s ease !important;\n}\n\n.chat-users__header .ant-input-affix-wrapper:focus-within {\n  background: #ffffff !important;\n  border-color: #2a9dc0 !important;\n  box-shadow: 0 0 0 3px rgba(42, 157, 192, 0.15) !important;\n}\n\n.chat-users__list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 8px 6px;\n}\n\n.chat-users__list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.chat-users__list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-users__list::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.25);\n  border-radius: 10px;\n}\n\n.chat-users__list::-webkit-scrollbar-thumb:hover {\n  background: rgba(148, 163, 184, 0.5);\n}\n\n.chat-users .chat-users__item {\n  min-height: 60px;\n  padding: 10px 12px;\n  margin: 2px 4px;\n  border-radius: 12px;\n  border: none !important;\n  cursor: pointer;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n}\n\n.chat-users .chat-users__item:hover {\n  background: #f8fafc;\n}\n\n.chat-users .chat-users__item:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px #2a9dc0;\n}\n\n.chat-users .chat-users__item.is-active {\n  background: #ecf7fb;\n}\n\n.chat-users .chat-users__item.is-active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 10px;\n  bottom: 10px;\n  width: 3.5px;\n  border-radius: 0 4px 4px 0;\n  background: linear-gradient(180deg, #2a9dc0 0%, #157f9f 100%);\n}\n\n[dir=\"rtl\"] .chat-users .chat-users__item.is-active::before {\n  left: auto;\n  right: 0;\n  border-radius: 4px 0 0 4px;\n}\n\n.chat-users__avatar {\n  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 2px 5px rgba(21, 127, 159, 0.2);\n}\n\n.chat-users .chat-users__item .ant-list-item-meta {\n  align-items: center;\n  min-width: 0;\n}\n\n.chat-users .chat-users__item .ant-list-item-meta-content {\n  min-width: 0;\n}\n\n.chat-users .chat-users__item .ant-list-item-meta-title {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.3;\n}\n\n.chat-users .chat-users__item.is-active .ant-list-item-meta-title {\n  color: #0e6580;\n  font-weight: 700;\n}\n\n.chat-users .chat-users__item .ant-list-item-meta-description {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.8125rem;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.chat-users .chat-users__item.is-active .ant-list-item-meta-description {\n  color: #334a60;\n}\n\n.chat-users__unread-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background-color: #157f9f;\n  box-shadow: 0 0 0 2px #ffffff, 0 0 8px rgba(21, 127, 159, 0.5);\n  display: inline-block;\n  flex-shrink: 0;\n  margin-left: 6px;\n}\n\n[dir=\"rtl\"] .chat-users__unread-dot {\n  margin-left: 0;\n  margin-right: 6px;\n}\n\n/* Phones/tablets: the list is the whole screen until a conversation opens. */\n.chat-page--compact .chat-users {\n  width: 100%;\n  border-inline-end: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
